var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"intro-card"},[_c('img',{staticClass:"card-image",attrs:{"src":_vm.card.image,"alt":_vm.card.title,"loading":"lazy"}}),_vm._v(" "),_c('h4',{staticClass:"title"},[_vm._v(_vm._s(_vm.card.title))]),_vm._v(" "),_c('p',{staticClass:"description"},[_vm._v("\n    "+_vm._s(_vm.card.description)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bbfb12d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bootcamp/enroll/intro/IntroCard.vue
// module id = null
// module chunks = 